<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__rdadvertiser}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.accountId" placeholder="授权账号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.advertiserName" placeholder="广告主名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
        <el-select v-model="dataForm.role" clearable placeholder="请选择角色">
          <el-option
                  v-for="item in roles"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.advertiserStatus" clearable placeholder="请选择状态">
            <el-option
                    v-for="item in advertiserStatuss"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('demo:rdadvertiser:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('demo:rdadvertiser:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
<!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="advertPlatform" label="所属广告平台" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="accountId" label="授权账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="advertiserId" label="广告主账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="advertiserName" label="广告主名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="role" label="角色" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.role === 'ROLE_ADVERTISER'" size="small">普通广告主（直客）</el-tag>
            <el-tag v-if="scope.row.role === 'ROLE_CHILD_ADVERTISER'" size="small">普通广告主（代理商子客户）</el-tag>
            <el-tag v-if="scope.row.role === 'ROLE_CHILD_AGENT'" size="small">二级代理商</el-tag>
            <el-tag v-if="scope.row.role === 'ROLE_AGENT'" size="small">一级代理商</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="advertiserStatus" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_DISABLE'" size="small">已禁用</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_PENDING_CONFIRM'" size="small">申请待审核</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_PENDING_VERIFIED'" size="small">待验证</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_CONFIRM_FAIL'" size="small">审核不通过</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_ENABLE'" size="small">已审核</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_CONFIRM_FAIL_END'" size="small">CRM审核不通过</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_PENDING_CONFIRM_MODIFY'" size="small">修改待审核</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_CONFIRM_MODIFY_FAIL'" size="small">修改审核不通过</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_LIMIT'" size="small">限制</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_WAIT_FOR_BPM_AUDIT'" size="small">等待CRM审核</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_WAIT_FOR_PUBLIC_AUTH'" size="small">待对公验证</el-tag>
            <el-tag v-if="scope.row.advertiserStatus === 'STATUS_SELF_SERVICE_UNAUDITED'" size="small">自助开户待验证资质</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="licenseUrl" label="执照预览地址" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="licenseNo" label="执照编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="licenseProvince" label="执照省份" header-align="center" align="center"></el-table-column>
        <el-table-column prop="licenseCity" label="执照城市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="company" label="公司名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="brand" label="经营类别" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promotionArea" label="运营区域" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promotionCenterProvince" label="运营省份" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promotionCenterCity" label="运营城市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="firstIndustryName" label="一级行业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="secondIndustryName" label="二级行业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reason" label="审核拒绝原因" header-align="center" align="center"></el-table-column>
        <el-table-column prop="advertiserCreateTime" label="广告主创建时间" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button v-if="$hasPermission('demo:rdadvertiser:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
<!--            <el-button v-if="$hasPermission('demo:rdadvertiser:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './rdadvertiser-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/rdadvertiser/page',
        getDataListIsPage: true,
        exportURL: '/sys/rdadvertiser/export',
        deleteURL: '/sys/rdadvertiser',
        deleteIsBatch: true
      },
      roles:[
        {
          'label':'普通广告主（直客）',
          'value':'ROLE_ADVERTISER',
        },
        {
          'label':'普通广告主（代理商子客户）',
          'value':'ROLE_CHILD_ADVERTISER',
        },
        {
          'label':'一级代理商',
          'value':'ROLE_AGENT',
        },
        {
          'label':'二级代理商',
          'value':'ROLE_CHILD_AGENT',
        }
      ],
      advertiserStatuss:[
        {
          'label':'已禁用',
          'value':'STATUS_DISABLE',
        },
        {
          'label':'申请待审核',
          'value':'STATUS_PENDING_CONFIRM',
        },
        {
          'label':'待验证',
          'value':'STATUS_PENDING_VERIFIED',
        },
        {
          'label':'审核不通过',
          'value':'STATUS_CONFIRM_FAIL',
        },
        {
          'label':'已审核',
          'value':'STATUS_ENABLE',
        },
        {
          'label':'CRM审核不通过',
          'value':'STATUS_CONFIRM_FAIL_END',
        },
        {
          'label':'修改待审核',
          'value':'STATUS_PENDING_CONFIRM_MODIFY',
        },
        {
          'label':'修改审核不通过',
          'value':'STATUS_CONFIRM_MODIFY_FAIL',
        },
        {
          'label':'限制',
          'value':'STATUS_LIMIT',
        },
        {
          'label':'等待CRM审核',
          'value':'STATUS_WAIT_FOR_BPM_AUDIT',
        },
        {
          'label':'待对公验证',
          'value':'STATUS_WAIT_FOR_PUBLIC_AUTH',
        },
        {
          'label':'自助开户待验证资质',
          'value':'STATUS_SELF_SERVICE_UNAUDITED',
        }
    ],
      dataForm: {
        id: '',
        advertiserStatus:'',
        role:'',
        accountId:'',
        advertiserId:'',
        advertiserName:''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
